import { useEffect, useState } from "react";
import { DollarSign, ShoppingBag, Users, Mail, TrendingUp, AlertTriangle } from "lucide-react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AdminDashboard() {
  const { user } = useAuth();
  const [r, setR] = useState(null);
  useEffect(() => { api.get("/admin/reports").then(({ data }) => setR(data)).catch(() => {}); }, []);
  if (!r) return <p className="font-heading text-2xl text-ink/40">Loading…</p>;

  const cards = [];
  if (r.total_sales !== undefined) cards.push(["Total Sales", `$${r.total_sales.toFixed(2)}`, DollarSign]);
  if (r.net_revenue !== undefined) cards.push([user.role === "super_admin" ? "Net Store Payout" : "Net Revenue", `$${r.net_revenue.toFixed(2)}`, TrendingUp]);
  if (r.agency_earnings !== undefined) cards.push(["Agency Earnings", `$${r.agency_earnings.toFixed(2)}`, Wallet2]);
  cards.push(["Paid Orders", r.orders_paid, ShoppingBag]);
  if (user.role !== "fulfillment_staff") { cards.push(["Customers", r.customers, Users]); cards.push(["Subscribers", r.subscribers, Mail]); }

  return (
    <div data-testid="admin-dashboard">
      <h1 className="font-heading text-4xl tracking-tight mb-2">Dashboard</h1>
      <p className="font-body text-sm text-ink/60 mb-8">
        {user.role === "fulfillment_staff" ? "Your fulfillment overview — process and ship orders." :
         user.role === "store_manager" ? "Your store performance at a glance." : "Full platform overview across the agency portfolio."}
      </p>

      <div className="grid grid-cols-2 md:grid-cols-3 gap-4 mb-10">
        {cards.map(([l, v, Icon], i) => (
          <div key={i} className="adm-card flex items-center justify-between" data-testid={`stat-${l.toLowerCase().replace(/\s/g, "-")}`}>
            <div><p className="adm-label">{l}</p><p className="font-heading text-3xl">{v}</p></div>
            <Icon size={24} strokeWidth={1.25} className="text-ink/30" />
          </div>
        ))}
      </div>

      {user.role !== "fulfillment_staff" && (
        <div className="grid md:grid-cols-2 gap-6">
          <div className="adm-card">
            <h3 className="font-heading text-xl mb-4">Top Pieces</h3>
            {r.top_products.length === 0 ? <p className="text-sm text-ink/50">No sales yet.</p> :
              <ul className="space-y-2">{r.top_products.map((p, i) => (
                <li key={i} className="flex justify-between font-body text-sm border-b border-ink/5 pb-2"><span>{p.title}</span><span className="text-ink/60">{p.sold} sold</span></li>
              ))}</ul>}
          </div>
          <div className="adm-card">
            <h3 className="font-heading text-xl mb-4 flex items-center gap-2"><AlertTriangle size={16} strokeWidth={1.5} /> Low Stock</h3>
            {r.low_stock.length === 0 ? <p className="text-sm text-ink/50">All sizes healthy.</p> :
              <ul className="space-y-2">{r.low_stock.map((p, i) => (
                <li key={i} className="flex justify-between font-body text-sm border-b border-ink/5 pb-2"><span>{p.product} · {p.size}</span><span className={p.stock <= 0 ? "text-destructive" : "text-ink/60"}>{p.stock} left</span></li>
              ))}</ul>}
          </div>
        </div>
      )}
    </div>
  );
}

function Wallet2(props) { return <TrendingUp {...props} />; }
